export default __webpack_public_path__ + "static/media/thumb_bill_reynolds.51e5fede.jpg";